/**
 * Production KaTeX Configuration
 * 
 * Philosophy: MINIMAL preprocessing - backend already formatted everything
 * Only fix critical issues that might have escaped backend
 * 
 * Used by: ChatPage.jsx (MarkdownMath component)
 */

import 'katex/dist/katex.min.css';
import katex from 'katex';

/**
 * Configure KaTeX for production.
 * Call this ONCE on app initialization.
 */
export function initKaTeX() {
    window.katex = katex;

    /**
     * Minimal preprocessing - only fix critical issues
     * Backend (LaTeXFormatter.py) already did comprehensive formatting
     */
    window.preprocessLatex = (text) => {
        if (!text) return text;

        // ONLY these critical fixes (3 steps):
        
        // 1. Remove control characters (in case they slipped through)
        text = text.replace(/[\x00-\x08\x0b\x0c\x0e-\x1f]/g, '');

        // 2. Fix form feed corruption (\\f -> \\frac) - most common issue
        text = text.replace(/\\f\\frac/g, '\\frac');
        text = text.replace(/\\f\{/g, '\\frac{');
        text = text.replace(/\f/g, ''); // Actual form feed character

        // 3. Minor delimiter spacing fixes only (backend handled the rest)
        text = text.replace(/\$\s+/g, '$');  // Remove space after $
        text = text.replace(/\s+\$(?!\$)/g, '$');  // Remove space before $ (but not $$)

        return text;
    };

    console.log('✅ KaTeX initialized for production rendering');
}

/**
 * Render LaTeX in container.
 * Usage: After content is added to DOM, call renderMathInContainer(element)
 * 
 * Note: rehype-katex plugin handles automatic rendering
 * This is just a helper if needed for manual rendering
 */
export function renderMathInContainer(element = document.body) {
    if (!window.katex) {
        console.warn('⚠️ KaTeX not initialized');
        return;
    }

    try {
        // KaTeX auto-render is handled by rehype-katex plugin
        // This is just a helper if needed for manual rendering
        window.katex.render = window.katex.render || (() => {});
    } catch (e) {
        console.error('❌ Error rendering math:', e);
    }
}


